export default {
    MAX_DATE_RANGE_LIMIT: 90
  };
  